import { SxProps } from '@mui/material'
import { bannerClasses } from '../Banner.data'

interface BannerBackgroundElementsStyles {
  backgroundImage: SxProps
  backgroundGradient: SxProps
  bannerBackgroundColor: SxProps
}

export const bannerBackgroundElementsStyles: BannerBackgroundElementsStyles = {
  // Replicates next/image `fill`: absolutely fills the relatively-positioned banner section
  backgroundImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  backgroundGradient: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    inset: 0,
    color: 'transparent',
    zIndex: -1,

    '&::after': {
      position: 'absolute',
      height: '100%',
      width: '100%',
      content: '""',
      top: 0,
      left: 0,
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.50) 100%)',
    },
  },
  bannerBackgroundColor: {
    backgroundColor: 'utils.gray950',
    position: 'absolute',
    height: '100%',
    width: '100%',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    color: 'transparent',
    zIndex: -2,

    [`.${bannerClasses.smokyBlack} &`]: {
      backgroundColor: 'primary.smokyBlack',
    },
  },
}
